<div class="p-2 sm:p-4" #topDiv>
  @if (form()) {
    @if (fields()) {
      <form [formGroup]="form()" #dataForm="ngForm">
        <formly-form 
          [model]="dataModel()" 
          [fields]="fields()" 
          [options]="options()" 
          [form]="form()"/>
        <div class="flex flex-row w-full" 
          [class.justify-end]="buttonPositionAtEnd()"
          [class.justify-between]="!buttonPositionAtEnd()">
          @if (!hideCancel()) {
            <button type="button" (click)="onCancel()" mat-raised-button>
              <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:arrow-circle-left'"></mat-icon>
              Cancel
            </button>
          }
          @if (submitActions()?.length) {
            <button type="button" mat-raised-button color="primary" [matMenuTriggerFor]="submitActionsMenu"
              aria-label="Submit actions">
              Save
              <mat-icon svgIcon="heroicons_outline:menu"></mat-icon>
            </button>
            <mat-menu #submitActionsMenu="matMenu">
              @for (btn of submitActions(); track btn) {
                <button type="submit" mat-menu-item
                  (click)="onSubmit(btn.keepOpen || false, btn)">
                  <mat-icon [svgIcon]=" btn.icon"></mat-icon>
                  <span>{{btn.label}}</span>
                </button>
              }
            </mat-menu>
          }
          @if (!submitActions()?.length) {
            @if (!hideSubmit() && keepOpen()) {
              <button type="button" color="primary" mat-raised-button
                [disabled]="isDisabled() || isUploading()" (click)="onSubmit(true)">
                {{submitAnotherLabel()}}
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
            }
            @if (!hideSubmit()) {
              <button [type]="'submit'" color="primary" mat-raised-button
                [disabled]="isDisabled() || isUploading()" (click)="onSubmit(false)">
                {{submitLabel()}}
                <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
              </button>
            }
          }
        </div>
      </form>
    }
  }
</div>